<script>
import moment from 'moment';

export default {
  props: ['item', 'pc'],
  data() {
    return {
      show_share: false,
      show_offer: false,
      show_login: false,

    }
  },
  computed: {
    days_on_market() {
      if(["Coming Soon", "Active", "Active Under Contract", "Pending"].includes(this.item.StandardStatus)) {
        return moment().diff(moment(this.item.OriginalEntryTimestamp), 'days');
      } else {
        return '';
      }
    },
    price_sqft() {
      var out = '';
      if(this.item.ListPrice && this.item.LivingArea) { out = this.formatPrice(this.item.ListPrice/this.item.LivingArea); }
      return out;
    }
  },
  created() {
    
  },
  methods: {
    saveFavorite() {
      if(this.disabled == true) { this.$noty.warning('Disabled'); return; } this.disabled = true;
      this.$http.post('/mlss/store-favorites', {ListingId: this.item.ListingId}).then(res => {
        console.log(res);
        if(res.data.created == 'yes') { this.item.favorites.push(res.data.data); }
        else { this.item.favorites = []; }
        if(res.data.message != null && res.data.message.length > 0){ this.$noty.success(res.data.message); }
        this.disabled = false;
      }).catch(res => { this.popupErrors(res); this.disabled = false; });
    },
    doclose() {
      this.$emit('doclose');
    },
    convertMapStyle() {
      var StaticParams = (function(){
          var _items = [], separator = '|', _parameters = '';
          function isColor(value){return /^#[0-9a-f]{6}$/i.test(value.toString());}
          function toColor(value){return '0x' + value.slice(1);}
          function parse(jsonString){
            var json;
            try { json = JSON.parse(jsonString); } catch (e){ return; }
            _items.length = 0;
            for(var i = 0; i < json.length; i++){
              var item = json[i], hasFeature = item.hasOwnProperty('featureType'), hasElement = item.hasOwnProperty('elementType'), stylers = item.stylers, target = '', style = '';
              if(!hasFeature && !hasElement){ target = 'feature:all'; }
              else { if(hasFeature){ target = 'feature:' + item.featureType; } if(hasElement){ target = target ? target + separator : ''; target += 'element:' + item.elementType; } }
              for(var s = 0; s< stylers.length; s++){ var styleItem = stylers[s], key = Object.keys(styleItem)[0]; style = style ? style + separator : ''; style += key + ':' + (isColor(styleItem[key]) ? toColor(styleItem[key]) : styleItem[key]); }
              _items.push(target + separator + style);
            }
          }
          return { get: function(){return '&style=' + _items.join('&style=');}, parse: parse }
      })();
      if(this.pc && this.pc.map_google_style) {
        StaticParams.parse(this.pc.map_google_style);
        return StaticParams.get();
      } else {
        return '&style=feature%3Aadministrative%7Celement%3Alabels.text.fill%7Ccolor%3A0x6195a0%7C&style=feature%3Aadministrative.province%7Celement%3Ageometry.stroke%7Cvisibility%3Aoff%7C&style=feature%3Alandscape%7Celement%3Ageometry%7Clightness%3A0%7Csaturation%3A0%7Ccolor%3A0xf5f5f2%7Cgamma%3A1%7C&style=feature%3Alandscape.man_made%7Celement%3Aall%7Clightness%3A-3%7Cgamma%3A1.00%7C&style=feature%3Alandscape.natural.terrain%7Celement%3Aall%7Cvisibility%3Aoff%7C&style=feature%3Apoi%7Celement%3Aall%7Cvisibility%3Aoff%7C&style=feature%3Apoi.park%7Celement%3Ageometry.fill%7Ccolor%3A0xbae5ce%7Cvisibility%3Aon%7C&style=feature%3Aroad%7Celement%3Aall%7Csaturation%3A-100%7Clightness%3A45%7Cvisibility%3Asimplified%7C&style=feature%3Aroad.highway%7Celement%3Aall%7Cvisibility%3Asimplified%7C&style=feature%3Aroad.highway%7Celement%3Ageometry.fill%7Ccolor%3A0xfac9a9%7Cvisibility%3Asimplified%7C&style=feature%3Aroad.highway%7Celement%3Alabels.text%7Ccolor%3A0x4e4e4e%7C&style=feature%3Aroad.arterial%7Celement%3Alabels.text.fill%7Ccolor%3A0x787878%7C&style=feature%3Aroad.arterial%7Celement%3Alabels.icon%7Cvisibility%3Aoff%7C&style=feature%3Atransit%7Celement%3Aall%7Cvisibility%3Asimplified%7C&style=feature%3Atransit.station.airport%7Celement%3Alabels.icon%7Chue%3A0x0a00ff%7Csaturation%3A-77%7Cgamma%3A0.57%7Clightness%3A0%7C&style=feature%3Atransit.station.rail%7Celement%3Alabels.text.fill%7Ccolor%3A0x43321e%7C&style=feature%3Atransit.station.rail%7Celement%3Alabels.icon%7Chue%3A0xff6c00%7Clightness%3A4%7Cgamma%3A0.75%7Csaturation%3A-68%7C&style=feature%3Awater%7Celement%3Aall%7Ccolor%3A0xeaf6f8%7Cvisibility%3Aon%7C&style=feature%3Awater%7Celement%3Ageometry.fill%7Ccolor%3A0xc7eced%7C&style=feature%3Awater%7Celement%3Alabels.text.fill%7Clightness%3A-49%7Csaturation%3A-53%7Cgamma%3A0.79%7C';
      }
    },
  }
  
}
</script>

<template>
  <div class="">

    <div class="p-2 border-bottom border-light">
      <w-image-slider v-if="item.images && item.images.length" :images="item.images"></w-image-slider>
      <img v-else class="w-100" :src="(item.thumbnail ? formatImage(item.thumbnail) : 'https://maps.googleapis.com/maps/api/streetview?size=640x480&location='+eurl(item.Latitude+','+item.Longitude)+'&pitch=10&key='+google_key)">
    </div>

    <div class="row m-0 p-2rem border-bottom border-light">
      <div class="_w-70"><Icon icon="mdi:sign-real-estate" class="mr-1" height="50" :class="item.StandardStatus.toLowerCase().includes('active')  ? 'text-success' : item.StandardStatus.toLowerCase().includes('closed') ? 'text-dark' : 'text-info'"></Icon></div>
      <div class="col-sm p-0">
        <h3 class="h2 m-0">{{formatPrice(item.ClosePrice ? item.ClosePrice : item.ListPrice, true, false)}}</h3>
        <h6 class="m-0"> {{item.StandardStatus}}</h6>
      </div>
      <div class="_w-200 text-right">
        <ul class="list-inline m-0">
          <li class="list-inline-item">
            <social-sharing :url="app_url+'/listing/'+item.ListingId"
              :title="app_name+' | '+
                (item.Address ? ''+item.Address : '')+
                (item.City ? ' '+item.City : '')+
                (item.StateOrProvince ? ' '+item.StateOrProvince : '')+
                (item.PostalCode ? ' '+item.PostalCode : '')"
              :description="item.PublicRemarks"
              :quote="item.PublicRemarks"
              :media="item.thumbnail"
              inline-template>
              <span><network network="facebook"><button type="button" class="btn btn-outline-dark border-0 px-1" v-tippy content="Share on Facebook"><Icon icon="ri:facebook-box-line" width="30"></Icon></button></network></span>
            </social-sharing>
          </li>
          <li class="list-inline-item">
            <button type="button" class="btn btn-outline-dark border-0 px-1" v-tippy content="Share with a friend or send to your own email." @click="show_share = true"><Icon icon="ri:mail-open-line" width="30"></Icon></button>
            <transition name="fade">
              <share-listing v-if="show_share" :item="listing" @closeshare="show_share = false"></share-listing>
            </transition>
          </li>
          <li class="list-inline-item">
            <button type="button" class="btn btn-outline-dark border-0 px-1" v-tippy :content="item.favorites && item.favorites.length > 0 ? 'Remove from favorites' : 'Add to favorites'" @click="user.name ? saveFavorite() : show_login = true"><Icon icon="ri:heart-line" width="30" :class="item.favorites && item.favorites.length > 0 ? 'text-danger' : ''"></Icon></button>
            <transition name="fade">
              <popuplogin v-if="show_login" @closelogin="show_login = false"></popuplogin>
            </transition>

            
          </li>
        </ul>
      </div>
    </div>

    <div class="p-2rem m_p-25 border-bottom border-light">
      <h3 class="mb-4"><Icon icon="ri:bookmark-line" width="23" class="mr-2" :class="'text-'+website_id"></Icon>Overview</h3>
      <p class="mb-0">{{item.PublicRemarks}}</p>
    </div>
    <div class="p-2rem m_p-25 border-bottom border-light">
      <h3 class="mb-4"><Icon icon="ri:bookmark-line" width="23" class="mr-2" :class="'text-'+website_id"></Icon>Property details</h3>
      <div class="row mb-4 _f-s-13">
        <div class="col-6 col-md-4" v-if="item.BedroomsTotal > 0">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:bed-outline" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">BEDROOMS:</div>{{parseFloat(item.BedroomsTotal)}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.BathroomsTotalInteger > 0">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:shower" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">BATHROOMS:</div>{{parseFloat(item.BathroomsTotalInteger)}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.Stories > 0">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:home-minus-outline" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">FLOORS:</div>{{parseFloat(item.Stories)}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.LivingArea > 0">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:ruler-square" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">SQFT:</div>{{parseFloat(item.LivingArea)}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.LotSizeAcres > 0">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:tape-measure" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">ACRES:</div>{{parseFloat(item.LotSizeAcres)}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.YearBuilt > 0">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:timeline-clock-outline" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">YEAR BUILT:</div>{{parseFloat(item.YearBuilt)}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.GarageSpaces > 0">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:garage-open-variant" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">GARAGE SPACES:</div>{{parseFloat(item.GarageSpaces)}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.Heating">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:radiator" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">HEATING:</div>{{item.Heating}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.Cooling">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:air-filter" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">COOLING:</div>{{item.Cooling}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.PropertySubType">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:home-silo-outline" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">DWELLING TYPE:</div>{{item.PropertySubType}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.PoolFeatures">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:pool" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">POOL:</div>{{item.PoolFeatures}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.View">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:image-filter-hdr-outline" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">VIEWS:</div>{{item.View}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.Basement">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:stairs-down" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">BASEMENT:</div>{{item.Basement}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.SubdivisionName">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:home-group" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">SUBDIVISION:</div>{{item.SubdivisionName}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.OriginalEntryTimestamp">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:sign-real-estate" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">LISTED ON:</div>{{moment(item.OriginalEntryTimestamp).format('MM-DD-YYYY')}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.CloseDate">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:file-sign" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">SOLD ON:</div>{{moment(item.CloseDate).format('MM-DD-YYYY')}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.mls_title">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:source-branch" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">SOURCE:</div>{{item.mls_title}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.ListOfficeName">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:office-building-outline" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">BROKERAGE:</div>{{item.ListOfficeName}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.updated_at">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:calendar-clock" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">LAST UPDATED:</div>{{moment(item.updated_at).format('MM-DD-YYYY')}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.mls && item.mls.last_idx">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:calendar-clock" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">LAST CHECKED:</div>{{moment.utc(item.mls.last_idx).local().format('lll')}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="item.ListingId">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:database-outline" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">MLS ID:</div>{{item.ListingId}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="days_on_market">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:counter" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">DAYS ON MARKET:</div>{{days_on_market}}</div>
          </div>
        </div>
        <div class="col-6 col-md-4" v-if="price_sqft">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="mdi:currency-usd" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">PRICE/SQFT:</div>{{price_sqft}}</div>
          </div>
        </div>
        <!-- <div class="col-6 col-md-4">
          <div class="row mx-0 flex-nowrap mb-3">
            <div class="_w-50 _w-n-50 p-0"><Icon icon="ri:hotel-bed-line" width="35"></Icon></div>
            <div class="col p-0"><div class="font-weight-bold">FAVORITED:</div>0</div>
          </div>
        </div> -->
      </div>
      <div class="">
        <img class="rounded w-100 _box-shadow-0-1-4-b-2" :src="'https://maps.googleapis.com/maps/api/staticmap?center='+encodeURIComponent(item.Latitude+','+item.Longitude)+'&zoom=10&size=640x315&maptype=roadmap&markers=size:small|'+encodeURIComponent(item.Latitude+','+item.Longitude)+'&key='+google_key+convertMapStyle()">
      </div>
    </div>
    <div class="p-2rem m_p-25 border-bottom border-light">
      <h3 class="mb-4"><Icon icon="ri:bookmark-line" width="23" class="mr-2" :class="'text-'+website_id"></Icon>Legal details</h3>
      <div class="row small">
        <div class="col-12 mb-3">
          <span v-if="item.mls && item.mls.mls_disclaimer" class="text-pre-wrap">{{item.mls.mls_disclaimer}}</span>
          <span v-else-if="item.mls_title">
            * All information should be verified by the recipient and none is guaranteed as accurate by {{item.mls_title}}.<br>
            * Copyright {{moment().format('YYYY')}} {{item.mls_title}}, Inc. All rights reserved.
          </span>
        </div>
        <div class="col-12">
          <img v-if="item.mls && item.mls.mls_logo" :src="formatImage(item.mls.mls_logo)" class="_h-40">
        </div>
      </div>
    </div>

  </div>
</template>
